import { render, staticRenderFns } from "./tcustbase.vue?vue&type=template&id=ea72163a&scoped=true&"
import script from "./tcustbase.vue?vue&type=script&lang=js&"
export * from "./tcustbase.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase.vue?vue&type=style&index=0&id=ea72163a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea72163a",
  null
  
)

export default component.exports